import ContactDetail from "../components/ContactDetail";

function ContactDetails() {
  return <ContactDetail />;
}

export default ContactDetails;
